var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Profile h-100 flex-column text-center"},[_c('img',{staticStyle:{"width":"240px","margin-bottom":"20px"},attrs:{"src":_vm.userProfile.logo_thumbnail,"alt":_vm.userProfile.company_name}}),_c('br'),_vm._v(" "+_vm._s(this.resourceName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }